module.exports = __webpack_public_path__ + "img/Unidad22-1.8f6f64f9.png";